import * as Bowser from 'bowser'
import componentCodes from "@/assets/errors/componentCodes.json";
import errorCodes from "@/assets/errors/errorCodes.json";
import apiList from "@/assets/errors/apiList.json";
import { t } from "./locale";
import router from '@/service/router'

export function getMessageFromError (error, apiName) {
    let envData = Bowser.parse(window.navigator.userAgent)
    let platform = getPlatformCode(envData.os.name)
    let browser = getBrowserCode(envData.browser.name)
    let component = 'x'
    let apiCode = 'x'
    let app = 'x'
    let errorMessage
    let errorCode = error.code ? error.code : 1

    let foundComponentCode = componentCodes.find(element => element.component == router.currentRoute.name)
    if (foundComponentCode) component = foundComponentCode.code
    
    let foundApi = apiList.find(api => api.name === apiName)
    if (foundApi) {
        // show the custom error message if present, else show the default one, also if the api is not even listed
        apiCode = foundApi.apiCode
        const customErrorMessage = foundApi.customMessages[errorCode]
        if (customErrorMessage) {
            errorMessage = customErrorMessage
        } else { // show the default error message
            errorMessage = errorCodes[errorCode].defaultMessage
        }
    } else { // show the default error message
        errorMessage = errorCodes[errorCode].defaultMessage
    }

    switch (config.projectId) {
      case 'WebApp': app = 'w'; break;
      case 'DealerDashboard': app = 'd'; break;
      case 'MyAccount': app = 'm'; break;
      case 'UserPortal': app = 'u'; break;
      default: app = 'x';
    }

    let errorCodeObfuscation = platform + '.' + browser + '.' + app + '.' + component + '.' + errorCode + '.' + apiCode

    let completeErrorMsg = `${errorMessage} errorCode: ${errorCodeObfuscation}`
    console.log(completeErrorMsg)
    return completeErrorMsg
}

function getPlatformCode (platform) {
    if (platform) {
        platform = platform.toLowerCase()

        if (/windows/.test(platform)) return 'w'
        if (/macos/.test(platform)) return 'm'
        if (/linux/.test(platform)) return 'l'
        if (/ios/.test(platform)) return 'i'
        if (/android/.test(platform)) return 'a'
    }
    return 'x'
}

function getBrowserCode (browser) {
    if (browser) {
        browser = browser.toLowerCase()

        if (/opera/.test(browser)) return 'o'
        if (/internet explorer/.test(browser)) return 'i'
        if (/microsoft edge/.test(browser)) return 'e'
        if (/firefox/.test(browser)) return 'f'
        if (/chrome/.test(browser)) return 'c'
        if (/safari/.test(browser)) return 's'
    }
    return 'x'
}
